import { Injectable } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TableConfiguration} from "../../paginated-data-table/paginated-table-configuration.model";

@Injectable({
  providedIn: 'root'
})
export class LayoutService {


  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
  ) { }


  openPanel(queryParams: any) {
    const path = this.router.url.split('?')[0].split('/');
    this.router.navigate(path, {queryParams:queryParams}).then();
  }

  closePanel() {
    const path = this.router.url.split('?')[0].split('/');
    this.router.navigate(path).then();
  }

  setDeleted(itemId: any, tableConfiguration: any, value = true) {
    return {
      ...tableConfiguration,
      deleting: {[itemId]: value}
    }
  }

  resetDeleted(itemId: any, tableConfiguration: any) {
    return {
      ...tableConfiguration,
      deleting: {}
    }
  }

  setActive(itemId: any, tableConfiguration: TableConfiguration, value = true): TableConfiguration {
    return {
      ...tableConfiguration,
      active: {[itemId]: value}
    }
  }
}
